import { sortAlphaNumeric } from '@/mixins/SortRoutine'

export default {
  data() {
    return {
      sortField: 'name',
      sortReverse: false
    }
  },
  methods: {
    onSort(field) {
      if (field === this.sortField) {
        this.sortReverse = !this.sortReverse
      } else {
        this.sortReverse = false
        this.sortField = field
      }
    },
    // This method can be used in computed fields to sort the actual data
    sortArray(items) {
      return sortAlphaNumeric(items, this.sortField, this.sortReverse)
    }
  }
}
